/* FB04 PDP image navigation — thumbnails, prev/next arrows, keyboard, touch swipe, mouse drag. */
(function(){
  if (window.__fb4ThumbsBound) return;
  window.__fb4ThumbsBound = true;

  var SWIPE_THRESHOLD = 40; // px minimum horizontal distance to count as swipe

  function thumbsIn(pdp){
    return Array.prototype.slice.call(pdp.querySelectorAll('[data-fb4-thumb]'));
  }

  function activeIndex(pdp){
    var list = thumbsIn(pdp);
    for (var i = 0; i < list.length; i++) {
      if (list[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function selectThumb(pdp, thumb){
    if (!pdp || !thumb) return;
    Array.prototype.forEach.call(pdp.querySelectorAll('[data-fb4-thumb]'), function(t){
      t.classList.remove('is-active');
    });
    thumb.classList.add('is-active');
    var url = thumb.getAttribute('data-img-url');
    var mainWrap = pdp.querySelector('[data-fb4-main-img]');
    if (url && mainWrap) {
      var img = mainWrap.querySelector('img');
      if (img) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = url;
      }
    }
    if (typeof thumb.scrollIntoView === 'function') {
      try { thumb.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' }); } catch (e) {}
    }
  }

  function goByOffset(pdp, delta){
    if (!pdp) return;
    var list = thumbsIn(pdp);
    if (list.length < 2) return;
    var i = activeIndex(pdp);
    var next = (i + delta + list.length) % list.length;
    selectThumb(pdp, list[next]);
  }

  function pdpFrom(el){
    return el && el.closest ? el.closest('[data-fb4-pdp]') : null;
  }

  function bind(){
    // Click delegation — thumbnails + prev/next arrows.
    document.addEventListener('click', function(e){
      var target = e.target;
      if (!target || !target.closest) return;

      var prevBtn = target.closest('[data-fb4-nav-prev]');
      if (prevBtn) {
        e.preventDefault();
        e.stopPropagation();
        goByOffset(pdpFrom(prevBtn), -1);
        return;
      }

      var nextBtn = target.closest('[data-fb4-nav-next]');
      if (nextBtn) {
        e.preventDefault();
        e.stopPropagation();
        goByOffset(pdpFrom(nextBtn), 1);
        return;
      }

      var thumb = target.closest('[data-fb4-thumb]');
      if (thumb) {
        e.preventDefault();
        e.stopPropagation();
        selectThumb(pdpFrom(thumb), thumb);
        return;
      }
    }, true);

    // Keyboard arrows on desktop.
    document.addEventListener('keydown', function(e){
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var t = e.target;
      if (t && t.matches && t.matches('input, textarea, select, [contenteditable="true"]')) return;
      var pdp = document.querySelector('[data-fb4-pdp]');
      if (!pdp) return;
      var r = pdp.getBoundingClientRect();
      if (r.bottom < 0 || r.top > (window.innerHeight || 0)) return;
      goByOffset(pdp, e.key === 'ArrowLeft' ? -1 : 1);
    });

    // Unified pointer drag — works for touch, mouse, pen.
    var drag = null; // { pdp, img, startX, startY, id, dragging, moved }

    document.addEventListener('pointerdown', function(e){
      var mainImg = e.target.closest && e.target.closest('[data-fb4-main-img]');
      if (!mainImg) return;
      // Ignore clicks on the arrow buttons — they have their own handler.
      if (e.target.closest('[data-fb4-nav-prev], [data-fb4-nav-next]')) return;
      // Only primary button for mouse.
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      drag = {
        pdp: pdpFrom(mainImg),
        img: mainImg,
        startX: e.clientX,
        startY: e.clientY,
        id: e.pointerId,
        dragging: true,
        moved: false,
        pointerType: e.pointerType
      };
      // Visual affordance for mouse.
      if (e.pointerType === 'mouse') {
        mainImg.style.cursor = 'grabbing';
      }
    }, { passive: true });

    document.addEventListener('pointermove', function(e){
      if (!drag || !drag.dragging || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.startX;
      var dy = e.clientY - drag.startY;
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) drag.moved = true;
      // Prevent image drag ghost + text selection during a horizontal mouse drag.
      if (drag.pointerType === 'mouse' && Math.abs(dx) > Math.abs(dy)) {
        if (e.cancelable) e.preventDefault();
      }
    });

    function endDrag(e){
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.startX;
      var dy = e.clientY - drag.startY;
      var pdp = drag.pdp;
      if (drag.pointerType === 'mouse' && drag.img) drag.img.style.cursor = '';
      drag = null;
      // Must be a clear horizontal swipe.
      if (Math.abs(dx) < SWIPE_THRESHOLD) return;
      if (Math.abs(dy) > Math.abs(dx)) return;
      goByOffset(pdp, dx < 0 ? 1 : -1);
    }

    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', function(e){
      if (!drag || e.pointerId !== drag.id) return;
      if (drag.pointerType === 'mouse' && drag.img) drag.img.style.cursor = '';
      drag = null;
    });

    // Suppress the browser's native image drag ghost on the main image.
    document.addEventListener('dragstart', function(e){
      var main = e.target.closest && e.target.closest('[data-fb4-main-img]');
      if (main) e.preventDefault();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
